import React, { useState, useContext, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import Request from "../Utils/Request/Request";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getErrorMessage, showToast } from "../Utils/index";
import { AppStorage } from "../Utils/Context/AppContext";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import EditableLabel from "./EditableLabels";
import ProductExtraLabels from "./ProductExtraLabels";
import { getDocumentId } from "../Utils/documentNumber";

const normalizeInvoiceCategory = (category) => {
  const value = String(category || "").toUpperCase();
  if (value === "STDSI" || value === "STANDARD") return "Standard";
  if (value === "SIMSI" || value === "SIMPLIFIED") return "Simplified";
  return "";
};

const cleanInputValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "number" && Number.isNaN(value)) return "";
  return String(value).replace(/\r?\n/g, "");
};

const isBlankInputValue = (value) => cleanInputValue(value).trim() === "";

const cleanNumberValue = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : "";
};

const formatMoneyValue = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue.toFixed(2) : "";
};

const applyClientBuyerDetails = (target, client) => {
  target.address = client?.address ? client.address : "";
  target.buildingNumber = cleanInputValue(client?.buildingNumber);
  target.district = cleanInputValue(client?.district);
  target.cityName = cleanInputValue(client?.cityName);
  target.postalZone = cleanInputValue(client?.postalZone);
  target.buyerIdType = client?.buyerIdType || "VAT";
};

const AddedElement = ({
  index,
  setFormData,
  formData,
  product,
  singleProduct,
  validate,
  getInvoice,
  flag,
  duplicate,
  setProductLabels,
  productLabels,
  labels,
  setLabels
}) => {
  const { id } = useParams();
  const AppContext = useContext(AppStorage);
  const { t, i18n } = useTranslation();



  function getProductLabels() {
    Request.get("/getProductLabel")
      .then((result) => {
        const dataArray = result?.data?.data;
        if (Array.isArray(dataArray) && dataArray.length > 0) {
          setProductLabels((prevLabels) => ({
            ...prevLabels,
            ...dataArray[0],
          }));
        }
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response?.status === 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }


  useEffect(() => {
    if (AppContext?.userAuthToken || AppContext?.userAuthToken !== "") {
      getProductLabels();
    }
  }, [AppContext?.userAuthToken, AppContext?.userInfo]);

  function handleSave(field, newValue) {
    const updatedLabels = { ...productLabels, [field]: newValue };

    Request.post("/createOrUpdateProduct", updatedLabels)
      .then((res) => {
        showToast("success", "Saved successfully!");
        const savedLabels = res?.data?.data; // adjust based on your API response structure
        if (savedLabels) {
          setProductLabels(savedLabels); // use backend response
        }
      })
      .catch((err) => {
        showToast("error", err);
      });

  }


  const getExtraProductLabels = () => {
    Request.get("Labels")
      .then((result) => {
        setLabels(result?.data || []);
      })
      .catch((err) => {
        console.error("Error fetching labels:", err);
        showToast("error", "Something went wrong while fetching labels.");
      });
  };


  useEffect(() => {
    if (AppContext?.userAuthToken) {
      getExtraProductLabels();
    }
  }, [AppContext?.userAuthToken]);

  const addNewLabel = () => {
    setLabels([...labels, { valueLabel: "", isNew: true }]);
  };

  return (
    <Box className="portal-form">
      <Grid container spacing={2} sx={{ padding: "3px 0px" }}>
        <Grid item xs={12} sm={6} md={4} >
          {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
            <InputLabel>{t("Product")}</InputLabel>
          ) : (

            <EditableLabel
              // key={`editable-label-${productLabels.productName}-${index}`}
              label="Product"
              value={productLabels.productName}
              onSave={(newValue) => handleSave("productName", newValue)}
              isFirst={index === 0}
              showPen={AppContext?.userInfo?.allowTitlesEdit}
            />

          )}

          <Autocomplete
            size="small"
            options={product}
            getOptionLabel={(option) => option.name}
            value={
              product.find((item) => item.id === singleProduct.productId) ||
              null
            }
            onChange={(event, newValue) => {
              const dupObj = { ...formData };
              dupObj.invoiceproducts[index].productId = newValue
                ? newValue.id
                : "";
              dupObj.invoiceproducts[index].productName = newValue
                ? newValue.name
                : "";
              dupObj.invoiceproducts[index].vat =
                (product.find((item) => item.id === singleProduct.productId)
                  ?.vat /
                  100) *
                (
                  singleProduct?.unitPrice * singleProduct?.qty -
                  +singleProduct?.discount
                ).toFixed(2);
              dupObj.invoiceproducts[index].total = (
                singleProduct?.unitPrice * singleProduct?.qty
              ).toFixed(2);
              dupObj.invoiceproducts[index].totalAfterDiscount = (
                singleProduct?.unitPrice * singleProduct?.qty -
                +singleProduct?.discount
              ).toFixed(2);
              dupObj.invoiceproducts[index].totalAfterVat = (
                singleProduct?.unitPrice * singleProduct?.qty -
                +singleProduct?.discount +
                +singleProduct?.vat
              ).toFixed(2);
              setFormData(dupObj);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  readOnly:
                    flag === false && id !== undefined && duplicate !== true,
                }}
                sx={{
                  "& .MuiInputLabel-shrink": { color: "#41c1ba !important" },
                  "& fieldset": { borderColor: "#41c1ba !important" },
                }}
              />
            )}
          />
          {!validate &&
            (formData.invoiceproducts[index].productName === null ||
              formData.invoiceproducts[index].productName === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Product is required
              </div>
            )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
            <InputLabel>{t("Description")}</InputLabel>
          ) : (
            <EditableLabel
              showPen={AppContext?.userInfo?.allowTitlesEdit}
              label="Description"
              value={productLabels.description}
              onSave={(newValue) => handleSave("description", newValue)}
              isFirst={index === 0}
            />
          )}
          <TextField
            size="small"
            inputProps={{
              readOnly:
                flag === false && id != undefined && duplicate != true
                  ? true
                  : false,
            }}
            value={cleanInputValue(singleProduct?.description)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.invoiceproducts[index].description = e.target.value;
              setFormData(dupObj);
            }}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
              width: "100%",
            }}
          />
          {!validate &&
            (formData.invoiceproducts[index].description === null ||
              formData.invoiceproducts[index].description === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Add description
              </div>
            )}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
            <InputLabel>{t("Unit")}</InputLabel>
          ) : (
            <EditableLabel
              showPen={AppContext?.userInfo?.allowTitlesEdit}
              label="Unit"
              value={productLabels.unit}
              onSave={(newValue) => handleSave("unit", newValue)}
              isFirst={index === 0}
            />
          )}
          <TextField
            size="small"
            inputProps={{
              readOnly:
                flag === false && id != undefined && duplicate != true
                  ? true
                  : false,
            }}
            value={cleanInputValue(singleProduct?.unit)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.invoiceproducts[index].unit = e.target.value;
              setFormData(dupObj);
            }}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
              width: "100%",
            }}
          />
          {!validate &&
            (formData.invoiceproducts[index].unit === null ||
              formData.invoiceproducts[index].unit === "") && (
              <div style={{ color: "red", fontSize: "small" }}>Add Unit</div>
            )}
        </Grid>
        <Grid item xs={12} sm={4} md={1}>
          {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
            <InputLabel>{t("Qty")}</InputLabel>
          ) : (
            <EditableLabel
              showPen={AppContext?.userInfo?.allowTitlesEdit}
              label="Qty"
              value={productLabels.qty}
              onSave={(newValue) => handleSave("qty", newValue)}
              isFirst={index === 0}
            />
          )}
          <TextField
            size="small"
            inputProps={{
              readOnly:
                flag === false && id != undefined && duplicate != true
                  ? true
                  : false,
            }}
            type={"number"}
            value={cleanInputValue(singleProduct?.qty)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.invoiceproducts[index].qty = e.target.value;
              dupObj.invoiceproducts[index].vat =
                (product.find((item) => item.id === singleProduct.productId)
                  ?.vat /
                  100) *
                (singleProduct?.unitPrice * singleProduct?.qty -
                  +singleProduct?.discount);
              dupObj.invoiceproducts[index].total = (
                singleProduct?.unitPrice * singleProduct?.qty
              ).toFixed(2);
              dupObj.invoiceproducts[index].totalAfterDiscount = (
                singleProduct?.unitPrice * singleProduct?.qty -
                +singleProduct?.discount
              ).toFixed(2);
              dupObj.invoiceproducts[index].totalAfterVat = (
                singleProduct?.unitPrice * singleProduct?.qty -
                +singleProduct?.discount +
                +singleProduct?.vat
              ).toFixed(2);
              setFormData(dupObj);
            }}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
            }}
          />
          {!validate &&
            (formData.invoiceproducts[index].qty === null ||
              formData.invoiceproducts[index].qty === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Add Quantity
              </div>
            )}
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
            <InputLabel>{t("Unit Price")}</InputLabel>
          ) : (
            <EditableLabel
              showPen={AppContext?.userInfo?.allowTitlesEdit}
              label="Unit Price"
              value={productLabels.unitPrice}
              onSave={(newValue) => handleSave("unitPrice", newValue)}
              isFirst={index === 0}
            />
          )}
          <TextField
            type={"number"}
            inputProps={{
              readOnly:
                flag === false && id != undefined && duplicate != true
                  ? true
                  : false,
            }}
            size="small"
            value={cleanInputValue(singleProduct?.unitPrice)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.invoiceproducts[index].unitPrice = e.target.value;
              dupObj.invoiceproducts[index].vat =
                (product.find((item) => item.id === singleProduct.productId)
                  ?.vat /
                  100) *
                (
                  singleProduct?.unitPrice * singleProduct?.qty -
                  +singleProduct?.discount
                ).toFixed(2);
              dupObj.invoiceproducts[index].total = (
                singleProduct?.unitPrice * singleProduct?.qty
              ).toFixed(2);
              dupObj.invoiceproducts[index].totalAfterDiscount = (
                singleProduct?.unitPrice * singleProduct?.qty -
                +singleProduct?.discount
              ).toFixed(2);
              dupObj.invoiceproducts[index].totalAfterVat = (
                singleProduct?.unitPrice * singleProduct?.qty -
                +singleProduct?.discount +
                +singleProduct?.vat
              ).toFixed(2);
              setFormData(dupObj);
            }}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
            }}
          />
          {!validate &&
            (formData.invoiceproducts[index].unitPrice === null ||
              formData.invoiceproducts[index].unitPrice === "") && (
              <div style={{ color: "red", fontSize: "small" }}>Enter Price</div>
            )}
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
            <InputLabel>{t("Total")}</InputLabel>
          ) : (
            <EditableLabel
              showPen={AppContext?.userInfo?.allowTitlesEdit}
              label="Total"
              value={productLabels.total}
              onSave={(newValue) => handleSave("total", newValue)}
              isFirst={index === 0}
            />
          )}
          <TextField
            size="small"
            inputProps={{ readOnly: true }}
            type={"number"}
            value={cleanInputValue(singleProduct?.total)}
            sx={{
              "& input": {
                color: "grey !important",
              },
              "& .MuiInputLabel-shrink": {
                color: "#A0A0A0 !important",
              },
              "& fieldset": {
                borderColor: "#A0A0A0 !important",
                "& legend": {
                  "& span": {
                    color: "#A0A0A0 !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#A0A0A0",
              },
              width: "100%",
            }}
          />
          {!validate &&
            (formData.invoiceproducts[index].total === null ||
              formData.invoiceproducts[index].total === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                total is required
              </div>
            )}
        </Grid>
        {AppContext?.userInfo?.addDiscount === true && (
          <>
            <Grid item xs={12} sm={6} md={2}>
              {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
                <InputLabel>{t("Discount")}</InputLabel>
              ) : (
                <EditableLabel
                  showPen={AppContext?.userInfo?.allowTitlesEdit}
                  label="Discount"
                  value={productLabels.discount}
                  onSave={(newValue) => handleSave("discount", newValue)}
                  isFirst={index === 0}
                />
              )}
              <TextField
                size="small"
                type={"number"}
                inputProps={{
                  readOnly:
                    flag === false && getInvoice != null && duplicate != true
                      ? true
                      : false,
                }}
                value={cleanNumberValue(singleProduct?.discount)}
                onChange={(e) => {
                  const dupObj = { ...formData };
                  dupObj.invoiceproducts[index].discount = e.target.value;
                  dupObj.invoiceproducts[index].vat =
                    (product.find((item) => item.id === singleProduct.productId)
                      ?.vat /
                      100) *
                    (
                      singleProduct?.unitPrice * singleProduct?.qty -
                      +singleProduct?.discount
                    ).toFixed(2);
                  dupObj.invoiceproducts[index].totalAfterDiscount = (
                    singleProduct?.unitPrice * singleProduct?.qty -
                    +singleProduct?.discount
                  ).toFixed(2);
                  dupObj.invoiceproducts[index].totalAfterVat = (
                    singleProduct?.unitPrice * singleProduct?.qty -
                    +singleProduct?.discount +
                    +singleProduct?.vat
                  ).toFixed(2);
                  setFormData(dupObj);
                }}
                sx={{
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                  width: "100%",
                }}
              />
              {!validate &&
                (formData.invoiceproducts[index].discount === null ||
                  formData.invoiceproducts[index].discount === "") && (
                  <div style={{ color: "red", fontSize: "small" }}>
                    Add Discount
                  </div>
                )}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
                <InputLabel>{t("Total After Discount")}</InputLabel>
              ) : (
                <EditableLabel
                  showPen={AppContext?.userInfo?.allowTitlesEdit}
                  label="Total After Discount"
                  value={productLabels.totalAfterDiscount}
                  onSave={(newValue) =>
                    handleSave("totalAfterDiscount", newValue)
                  }
                  isFirst={index === 0}
                />
              )}
              <TextField
                size="small"
                type={"number"}
                inputProps={{ readOnly: true }}
                value={cleanInputValue(singleProduct?.totalAfterDiscount)}
                sx={{
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                  width: "100%",
                }}
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={4} md={1}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
              <InputLabel>{t("Vat")}</InputLabel>
            ) : (
              <EditableLabel
                showPen={AppContext?.userInfo?.allowTitlesEdit}
                label="Vat"
                value={productLabels.vat}
                onSave={(newValue) => handleSave("vat", newValue)}
                isFirst={index === 0}
              />
            )}
            {product.find((item) => item.id === singleProduct.productId)?.vat}%
          </Box>
          <TextField
            type={"number"}
            size="small"
            inputProps={{ readOnly: true }}
            value={formatMoneyValue(singleProduct?.vat)}
            // onChange={(e) => {
            //   const dupObj = { ...formData };
            //   dupObj.invoiceproducts[index].vat = e.target.value;
            //   dupObj.invoiceproducts[index].totalAfterVat = (
            //     singleProduct.unitPrice * singleProduct.qty -
            //     +singleProduct.discount +
            //     +singleProduct?.vat
            //   );

            //   setFormData(dupObj);
            // }}
            sx={{
              "& input": {
                color: "grey !important",
              },
              "& .MuiInputLabel-shrink": {
                color: "#A0A0A0 !important",
              },
              "& fieldset": {
                borderColor: "#A0A0A0 !important",
                "& legend": {
                  "& span": {
                    color: "#A0A0A0 !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#A0A0A0",
              },
            }}
          />

          {!validate &&
            (formData.invoiceproducts[index].vat === null ||
              formData.invoiceproducts[index].vat === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                vat is required
              </div>
            )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {flag === true && AppContext?.userInfo?.allowTitlesEdit !== true ? (
            <InputLabel>{t("Total After Vat")}</InputLabel>
          ) : (
            <EditableLabel
              showPen={AppContext?.userInfo?.allowTitlesEdit}
              label="Total After Vat"
              value={productLabels.totalAfterVat}
              onSave={(newValue) => handleSave("totalAfterVat", newValue)}
              isFirst={index === 0}
            />
          )}
          <TextField
            size="small"
            type={"number"}
            inputProps={{ readOnly: true }}
            value={cleanInputValue(singleProduct?.totalAfterVat)}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
              width: "100%",
            }}
          />
        </Grid>
        {labels.map((label, labelIndex) => (
          <Grid item xs={12} sm={6} md={2} key={labelIndex}>
            <ProductExtraLabels
              labels={labels}
              setLabels={setLabels}
              label={label}
              labelIndex={labelIndex}
              index={index}
              singleProduct={singleProduct}
              formData={formData}
              setFormData={setFormData}
              isFirst={index === 0}
              showEdits={AppContext?.userInfo?.allowInvoiceProductExtra}
            />
          </Grid>
        ))}
        <Grid
          item
          xs={12}
          sm={1}
          md={1}
          sx={{ display: "flex", alignItems: "end" }}
        >
          <Button
            size="small"
            disabled={
              flag === false && id != undefined && duplicate != true
                ? true
                : false
            }
            onClick={() => {
              const dubObj = { ...formData };
              dubObj?.invoiceproducts.splice(index, 1);
              setFormData(dubObj);
            }}
            variant="contained"
            sx={{
              width: "100%",
              // marginTop: "21px",
              height: "40px",
              background: "#365b6d",
              padding: "11px 1px 7px",
              "&:hover": { backgroundColor: "#365b6d" },
            }}
          >
            X
          </Button>
        </Grid>
        {(index === 0 && AppContext?.userInfo?.allowInvoiceProductExtra === true) &&
          <Grid
            item
            xs={12}
            sm={1}
            md={1}
            sx={{ display: "flex", alignItems: "end" }}
          >
            <Button
              size="small"
              variant="contained"
              sx={{
                width: "100%",
                // marginTop: "21px",
                height: "40px",
                background: "#41c1ba",
                "&:hover": { backgroundColor: "#41c1ba" },
              }}
              onClick={addNewLabel}
            >
              +
            </Button>
          </Grid>
        }
      </Grid>

      <Divider sx={{ background: "#808b97", marginTop: "5px" }} />
    </Box>
  );
};

const ExtraValues = ({
  index,
  setFormData,
  formData,
  singleProduct,
  flag,
  duplicate,
}) => {
  const { id } = useParams();
  const AppContext = useContext(AppStorage);
  const { t, i18n } = useTranslation();

  return (
    <Box className="portal-form">
      <Grid container spacing={2} sx={{ padding: "3px 0px" }}>
        <Grid item xs={12} sm={6} md={4}>
          <InputLabel id="demo-simple-select-label">{t("Text")}</InputLabel>
          <TextField
            size="small"
            inputProps={
              {
                // readOnly: (flag === false && id != undefined) ? true : false,
              }
            }
            value={cleanInputValue(singleProduct?.text)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.extraValues[index].text = e.target.value;
              setFormData(dupObj);
            }}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
              width: "100%",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <InputLabel id="demo-simple-select-label">{t("Value")}</InputLabel>
          <TextField
            size="small"
            inputProps={
              {
                // readOnly: (flag === false && id != undefined) ? true : false,
              }
            }
            value={cleanInputValue(singleProduct?.value)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.extraValues[index].value = e.target.value;
              setFormData(dupObj);
            }}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
              width: "100%",
            }}
          />
        </Grid>

        <Grid item xs={12} sm={1} md={1}>
          <Button
            size="small"
            disabled={
              flag === false && id != undefined && duplicate != true
                ? true
                : false
            }
            onClick={() => {
              const dubObj = { ...formData };
              dubObj?.extraValues.splice(index, 1);
              setFormData(dubObj);
            }}
            variant="contained"
            sx={{
              width: "100%",
              marginTop: "21px",
              height: "40px",
              background: "#365b6d",
              padding: "11px 1px 7px",
              "&:hover": { backgroundColor: "#365b6d" },
            }}
          >
            X
          </Button>
        </Grid>
      </Grid>

      <Divider sx={{ background: "#808b97", marginTop: "5px" }} />
    </Box>
  );
};

const AddedValues = ({
  index,
  setFormData,
  formData,
  singleProduct,
  flag,
  duplicate,
  key
}) => {
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <Box className="portal-form">
      <Grid container spacing={2} sx={{ padding: "3px 0px" }}>
        <Grid item xs={12} sm={6} md={4}>
          <InputLabel id="demo-simple-select-label">{t("Text")}</InputLabel>
          <TextField
            size="small"
            inputProps={
              {
                // readOnly: (flag === false && id != undefined) ? true : false,
              }
            }
            value={cleanInputValue(singleProduct?.text)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.addedValues[index].text = e.target.value;
              setFormData(dupObj);
            }}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
              width: "100%",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <InputLabel id="demo-simple-select-label">{t("Value")}</InputLabel>
          <TextField
            size="small"
            inputProps={
              {
                // readOnly: (flag === false && id != undefined) ? true : false,
              }
            }
            value={cleanInputValue(singleProduct?.value)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.addedValues[index].value = e.target.value;
              setFormData(dupObj);
            }}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
              width: "100%",
            }}
          />
        </Grid>

        <Grid item xs={12} sm={1} md={1}>
          <Button
            size="small"
            disabled={
              flag === false && id != undefined && duplicate != true
                ? true
                : false
            }
            onClick={() => {
              const dubObj = { ...formData };
              dubObj?.addedValues.splice(index, 1);
              setFormData(dubObj);
            }}
            variant="contained"
            sx={{
              width: "100%",
              marginTop: "21px",
              height: "40px",
              background: "#365b6d",
              padding: "11px 1px 7px",
              "&:hover": { backgroundColor: "#365b6d" },
            }}
          >
            X
          </Button>
        </Grid>
      </Grid>

      <Divider sx={{ background: "#808b97", marginTop: "5px" }} />
    </Box>
  );
};

function AddInvoice({ flag, duplicate }) {
  const navigate = useNavigate();
  const AppContext = useContext(AppStorage);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const returnType = searchParams.get("returnType");
  const isSalesReturnDraft = duplicate === true && ["CREDIT_NOTE", "DEBIT_NOTE"].includes(returnType);
  const cancelPath = flag ? "/allOfferPrice" : isSalesReturnDraft ? "/allSalesReturn" : "/invoices";
  const initialState = {
    companyName: "",
    vatNumber: "",
    po: "",
    invoiceDate: dayjs(new Date()),
    payment: "",
    address: "",
    invoiceNumber: null,
    offerNumber: null,
    i_document_number: null,
    sr_document_number: null,
    po_document_number: null,
    id: null,
    discount: null,
    totalAfterDiscount: null,
    totalAfterVat: 0,
    notes: "",
    notes_2: "",
    vat: "",
    validity: "",
    bank_iban: null,
    clientNumber: null,
    clientPhone: null,
    buildingNumber: "",
    district: "",
    cityName: "",
    postalZone: "",
    buyerIdType: "VAT",

    invoiceproducts: [
      {
        productId: null,
        productName: "",
        description: "",
        qty: null,
        unitPrice: null,
        vat: "",
        total: null,
        unit: "",
        discount: 0,
        invoiceProductExtraLabels: [],
      },
    ],

    extraValues: [
      {
        text: "",
        value: null,
      },
    ],
    addedValues: [
      {
        text: "",
        value: "",
      },
    ],
    invoice_category: "Simplified", // Default to B2C Simplified
  };

  const [formData, setFormData] = useState(initialState);
  const [validated, setValidated] = useState(true);
  const [invoiceCategoryTouched, setInvoiceCategoryTouched] = useState(false);
  const [labels, setLabels] = useState([]);
  const [productLabels, setProductLabels] = useState({
    productName: "Product",
    description: "Description",
    qty: "Qty",
    unit: "Unit",
    unitPrice: "Unit Price",
    total: "Total",
    discount: "Discount",
    totalAfterDiscount: "Total After Discount",
    vat: "Vat",
    totalAfterVat: "Total After Vat",
  });

  const validateFormData = () => {
    const isPhase2 = Number(AppContext?.userInfo?.zatca_phase) === 2;
    const invoiceCategory = normalizeInvoiceCategory(formData.invoice_category) || "Simplified";
    const requiresDiscount = AppContext?.userInfo?.addDiscount === true;
    const missingRequiredField =
      isBlankInputValue(formData.vatNumber) ||
      (flag === false && isBlankInputValue(formData.payment)) ||
      formData.invoiceDate === "" ||
      formData.invoiceDate === null ||
      formData.invoiceproducts.length < 1 ||
      formData.invoiceproducts.some(
        (data) =>
          isBlankInputValue(data.productId) ||
          isBlankInputValue(data.productName) ||
          isBlankInputValue(data.description) ||
          isBlankInputValue(data.unitPrice) ||
          isBlankInputValue(data.qty) ||
          Number(data.qty) <= 0 ||
          isBlankInputValue(data.unit) ||
          (requiresDiscount && isBlankInputValue(data.discount))
      );
    const missingStandardBuyerField =
      invoiceCategory === "Standard" &&
      (isBlankInputValue(formData.companyName) ||
        isBlankInputValue(formData.vatNumber) ||
        cleanInputValue(formData.vatNumber).length !== 15 ||
        isBlankInputValue(formData.address) ||
        (isPhase2 &&
          (isBlankInputValue(formData.buildingNumber) ||
            isBlankInputValue(formData.district) ||
            isBlankInputValue(formData.cityName) ||
            !/^\d{5}$/.test(cleanInputValue(formData.postalZone)))));

    if (
      missingRequiredField ||
      missingStandardBuyerField
    ) {
      setValidated(false);
      showToast(
        "error",
        missingStandardBuyerField
          ? t("Please complete the buyer details required for Standard ZATCA invoices.")
          : t("Please complete the required invoice fields.")
      );
      return false;
    }
    setValidated(true);
    return true;
  };
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    if (validateFormData()) {
      setIsSubmitting(true);

      let tempData = {
        id: formData.id,
        i_document_number: !isSalesReturnDraft && flag !== true ? formData.i_document_number : null,
        sr_document_number: isSalesReturnDraft ? formData.sr_document_number : null,
        po_document_number: flag === true ? formData.po_document_number : null,
        companyName: formData.companyName,
        vatNumber: cleanInputValue(formData.vatNumber),
        po: cleanInputValue(formData.po),
        invoiceDate: new Date(formData.invoiceDate).setUTCHours(0, 0, 0, 0),
        payment: formData.payment,
        address: formData.address,
        notes: formData.notes,
        notes_2: formData.notes_2,
        validity: formData.validity,
        vat: formData.vat,
        bank_iban: formData.bank_iban,
        clientNumber: cleanInputValue(formData.clientNumber),
        companyNumber: cleanInputValue(formData.clientNumber),
        clientPhone: cleanInputValue(formData.clientPhone),
        buildingNumber: cleanInputValue(formData.buildingNumber),
        district: cleanInputValue(formData.district),
        cityName: cleanInputValue(formData.cityName),
        postalZone: cleanInputValue(formData.postalZone),
        buyerIdType: cleanInputValue(formData.buyerIdType),
        buyer_id_type: cleanInputValue(formData.buyerIdType),
        OfferPrice: flag === true ? true : false,
        discount: formData.invoiceproducts
          .map((item) => {
            const totalDiscount = parseFloat(item?.discount);
            return totalDiscount;
          })
          .reduce((accumulator, value) => {
            return +accumulator + +value;
          }, 0)?.toFixed(2),

        total: formData.invoiceproducts
          .map((item) => {
            const total = parseFloat(item?.unitPrice) * +item.qty;
            return total?.toFixed(2);
          })
          .reduce((accumulator, value) => {
            return +accumulator + +value;
          }, 0),

        totalAfterDiscount: formData.invoiceproducts
          .map((item) => {
            const total =
              parseFloat(item?.unitPrice) * +item.qty - +item.discount;
            return total;
          })
          .reduce((accumulator, value) => {
            return +accumulator + +value;
          }, 0)?.toFixed(2),

        totalAfterVat: formData.totalAfterVat,

        invoiceProducts: formData.invoiceproducts,
        extraValues: formData.extraValues,
        addedValues: formData.addedValues,
        invoice_category: normalizeInvoiceCategory(formData.invoice_category) || "Simplified",
        invoiceCategory: normalizeInvoiceCategory(formData.invoice_category) || "Simplified",
        zatca_invoice_type: normalizeInvoiceCategory(formData.invoice_category) || "Simplified",
        salesReturn: isSalesReturnDraft,
        zatca_return_type: isSalesReturnDraft ? returnType : null,
        original_invoice_id: isSalesReturnDraft ? Number(id) : null,
      };
      if (getInvoice === null || duplicate === true) {
        // setIsSubmitting(true);
        Request.post("/createInvoice", tempData)
          .then((result) => {
            setIsSubmitting(false);
            {
              flag === true
                ? showToast("success", "New Price Offer Added")
                : showToast("success", isSalesReturnDraft ? t("Sales return created successfully.") : "New Invoice Added");
            }
            flag === true
              ? navigate("/allOfferPrice")
              : navigate(isSalesReturnDraft ? "/allSalesReturn" : "/invoices");
          })
          .catch((err) => {
            setIsSubmitting(false);
            console.log("Error: ", err);
            if (err.response.status == 401) {
              showToast("error", "Unauthorized user.");
            } else if (err.response.status == 409) {
              showToast("error", getErrorMessage(err));
            } else {
              showToast("error", getErrorMessage(err));
            }
          });
      } else {
        tempData["id"] = getInvoice["id"];
        tempData["userId"] = getInvoice["userId"];
        // setIsSubmitting(true);
        Request.put("/updateInvoice", tempData)
          .then((result) => {
            setIsSubmitting(false);
            {
              flag === true
                ? showToast("success", "Price Offer Updated")
                : showToast("success", "Invoice Updated");
            }
            flag === true
              ? navigate("/allOfferPrice")
              : navigate("/invoices");
          })
          .catch((err) => {
            setIsSubmitting(false);
            console.log("Error: ", err);
            if (err.response.status == 401) {
              showToast("error", "Unauthorized user.");
            } else if (err.response.status == 409) {
              showToast("error", getErrorMessage(err));
            } else {
              showToast("error", getErrorMessage(err));
            }
          });
      }
    }
  };

  const [products, setProducts] = useState([]);
  const [clients, setClients] = useState([]);
  const [getInvoice, setGetInvoice] = useState(null);
  //   const [clientCompany, setClientCompany] = useState("");
  function getProducts() {
    Request.get("/getAllProducts")
      .then((result) => {
        // console.log(result);
        setProducts(result.data["data"]);
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }
  function getClients() {
    Request.get("/getAllClients")
      .then((result) => {
        setClients(result.data["data"]);
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }

  function getInvoices() {
    if (!id) return;
    Request.get(`/getUpdateInvoice/${id}`)
      .then((result) => {
        setGetInvoice(result.data);
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }
  const [offerNum, setOfferNum] = useState(0);
  const [invoiceNum, setInvoiceNum] = useState(0);
  const [salesReturnNum, setSalesReturnNum] = useState(0);
  useEffect(() => {
    Request.get("/getOfferNumber").then((result) => setOfferNum(Number(result.data.data) || 0)).catch(() => {});
    Request.get("/getInvoiceNumber").then((result) => setInvoiceNum(Number(result.data.data) || 0)).catch(() => {});
    Request.get("/getSalesReturnNumber").then((result) => setSalesReturnNum(Number(result.data.data) || 0)).catch(() => {});
  }, [AppContext?.userInfo, AppContext?.zatcaEnvironmentVersion]);

  useEffect(() => {
    if (getInvoice === null) {
      setFormData((current) => isSalesReturnDraft
        ? { ...current, sr_document_number: salesReturnNum + 1 }
        : flag === true
          ? { ...current, po_document_number: offerNum + 1 }
          : { ...current, i_document_number: invoiceNum + 1 });
    }
  }, [flag, getInvoice, duplicate, invoiceNum, offerNum, salesReturnNum, isSalesReturnDraft]);
  const isInitialLoad = useRef(false);
  useEffect(() => {
    if (getInvoice !== null) {
      isInitialLoad.current = true;
      let dupObj = { ...formData };
      dupObj.id = duplicate === true ? null : getInvoice?.id;
      dupObj.i_document_number = duplicate === true && !isSalesReturnDraft
        ? invoiceNum + 1
        : getInvoice?.i_document_number;
      dupObj.sr_document_number = duplicate === true && isSalesReturnDraft ? salesReturnNum + 1 : getInvoice?.sr_document_number;
      dupObj.po_document_number = duplicate === true
        ? (isSalesReturnDraft ? null : offerNum + 1)
        : getInvoice?.po_document_number;
      dupObj.companyName = getInvoice?.companyName;
      if (duplicate === true) {
        const findClient = clients.find(
          (data) => cleanInputValue(data.companyName) === cleanInputValue(getInvoice?.companyName)
        );
        const buyerDetailsSource = isSalesReturnDraft
          ? {
              address: getInvoice?.address || findClient?.address,
              buildingNumber: getInvoice?.buildingNumber || findClient?.buildingNumber,
              district: getInvoice?.district || findClient?.district,
              cityName: getInvoice?.cityName || findClient?.cityName,
              postalZone: getInvoice?.postalZone || findClient?.postalZone,
              buyerIdType: getInvoice?.buyerIdType || findClient?.buyerIdType,
            }
          : (findClient || getInvoice);
        dupObj.vatNumber = cleanInputValue(
          isSalesReturnDraft
            ? (getInvoice?.vatNumber || findClient?.vatNumber)
            : (findClient?.vatNumber ?? getInvoice?.vatNumber)
        );
        dupObj.clientNumber = cleanInputValue(
          findClient?.companyNumber ?? getInvoice?.clientNumber ?? getInvoice?.companyNumber
        );
        dupObj.clientPhone = cleanInputValue(
          findClient?.phoneNumber ?? getInvoice?.clientPhone
        );
        dupObj.po = cleanInputValue(getInvoice?.po);
        applyClientBuyerDetails(dupObj, buyerDetailsSource);
        dupObj.invoice_category =
          normalizeInvoiceCategory(findClient?.invoiceCategory || getInvoice?.invoice_category) || "Simplified";
      } else {
        dupObj.vatNumber = cleanInputValue(getInvoice?.vatNumber);
        dupObj.address = getInvoice?.address;
        dupObj.clientNumber = cleanInputValue(getInvoice?.clientNumber);
        dupObj.clientPhone = cleanInputValue(getInvoice?.clientPhone);
        dupObj.po = cleanInputValue(getInvoice?.po);
        dupObj.buildingNumber = cleanInputValue(getInvoice?.buildingNumber);
        dupObj.district = cleanInputValue(getInvoice?.district);
        dupObj.cityName = cleanInputValue(getInvoice?.cityName);
        dupObj.postalZone = cleanInputValue(getInvoice?.postalZone);
        dupObj.buyerIdType = getInvoice?.buyerIdType || "VAT";
      }
      dupObj.payment = getInvoice?.payment;
      dupObj.vat = getInvoice?.vat === null ? getInvoice?.invoiceproducts
        ?.map((item) => +item?.vat)
        .reduce((accumulator, value) => {
          return +accumulator + +value;
        }, 0) || 0 : getInvoice?.vat;
      dupObj.notes = getInvoice?.notes;
      dupObj.notes_2 = getInvoice?.notes_2;
      dupObj.totalAfterVat = getInvoice?.totalAfterVat;
      dupObj.validity = getInvoice?.validity;
      dupObj.bank_iban = getInvoice?.bank_iban;
      dupObj.invoiceDate =
        duplicate === true ? dayjs(new Date()) : dayjs(getInvoice?.invoiceDate);
      dupObj.invoiceproducts = !!getInvoice?.invoiceproducts?.length
        ? getInvoice?.invoiceproducts?.map((item) => {
          return {
            productId: item?.productId,
            productName: item?.productName,
            description: item?.description,
            qty: item?.qty,
            unitPrice: item?.unitPrice,
            vat: item?.vat,
            total: item?.total,
            unit: item?.unit,
            discount: item?.discount,
            totalAfterDiscount: item?.totalAfterDiscount,
            totalAfterVat: item?.totalAfterVat,
          };
        })
        : [
          {
            productId: null,
            productName: "",
            description: "",
            qty: null,
            unitPrice: null,
            vat: "",
            total: null,
            unit: "",
            discount: null,
            totalAfterDiscount: null,
            totalAfterVat: null,
          },
        ];
      dupObj.extraValues = !!getInvoice?.extravalues?.length
        ? getInvoice?.extravalues?.map((item) => {
          return {
            text: item?.text,
            value: item?.value,
          };
        })
        : [
          {
            text: "",
            value: null,
          },
        ];

      dupObj.invoice_category =
        normalizeInvoiceCategory(getInvoice?.invoice_category) || dupObj.invoice_category || "Simplified";

      setFormData(dupObj);
      setTimeout(() => {
        isInitialLoad.current = false;
      }, 3000);
    }
  }, [getInvoice, clients]);

  useEffect(() => {
    if (!duplicate || getInvoice === null) return;

    setFormData((current) => isSalesReturnDraft
      ? { ...current, sr_document_number: salesReturnNum + 1 }
      : flag === true
        ? { ...current, po_document_number: offerNum + 1 }
        : { ...current, i_document_number: invoiceNum + 1 });
  }, [duplicate, getInvoice, flag, invoiceNum, offerNum, salesReturnNum, isSalesReturnDraft]);

  useEffect(() => {
    if (AppContext?.userAuthToken || AppContext?.userAuthToken !== "") {
      getProducts();
      getClients();
      if (id) {
        getInvoices();
      }
    }
  }, [AppContext?.userAuthToken, AppContext?.userInfo]);

  const totalPrice =
    formData.invoiceproducts
      ?.map((item) => (parseFloat(item?.unitPrice) || 0) * (+item?.qty || 0))
      .reduce((accumulator, value) => {
        return +accumulator + +value;
      }, 0).toFixed(2) || 0;



  const vatPercentage =
    formData?.invoiceproducts?.length <= 1
      ? products.find(
        (item) => item.id === formData.invoiceproducts[0]?.productId
      )?.vat || 0
      : undefined;

  const calculateTotalAfterVat = () => {
    const calculatedTotalAfterVat =

      formData.invoiceproducts
        .map((item) => {
          const total =
            (parseFloat(item?.unitPrice) || 0) * (+item.qty || 0) -
            (+item.discount || 0)
          // (+item.vat || 0);
          return total;
        })
        .reduce((accumulator, value) => {
          return +accumulator + +value;
        }, 0) * 100
      / 100 + (+formData?.vat) || 0;

    const extraValuesTotal =
      formData.extraValues?.reduce((accumulator, extraValue) => {
        return accumulator + (parseFloat(extraValue.value) || 0);
      }, 0) || 0;

    const finalTotalAfterVat = (
      parseFloat(calculatedTotalAfterVat - extraValuesTotal)
    );


    setFormData((prevData) => ({
      ...prevData,
      totalAfterVat: finalTotalAfterVat.toFixed(2),
      // vat: totalVAT,
    }));
  };

  useEffect(() => {
    if (!isInitialLoad.current) {
      calculateTotalAfterVat();
    }
  }, [
    JSON.stringify(formData.invoiceproducts),
    JSON.stringify(formData.extraValues),
    JSON.stringify(formData.vat),
  ]);
  const calculateVat = () => {
    const totalVAT =

      (formData.invoiceproducts
        ?.map((item) => +item?.vat)
        .reduce((accumulator, value) => {
          return +accumulator + +value;
        }, 0).toFixed(2) || 0) * 100
      / 100;

    setFormData((prevData) => ({
      ...prevData,
      vat: totalVAT,
    }));
  };
  useEffect(() => {
    if (!isInitialLoad.current) {
      calculateVat();
    }
  }, [
    JSON.stringify(formData.invoiceproducts),
  ])

  return (
    <Box className="portal-form" sx={{ flexGrow: 1, width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 2 }}>
        <Typography variant="h6" sx={{ color: "#365b6d", fontWeight: 650 }}>
          {flag ? t("Price Offer") : isSalesReturnDraft ? t("Sales Return") : t("Invoice")}
        </Typography>
        <Button
          variant="outlined"
          onClick={() => navigate(cancelPath)}
          sx={{ whiteSpace: "nowrap", color: "#365b6d", borderColor: "#aebfc5", backgroundColor: "#fff", "&:hover": { borderColor: "#365b6d", backgroundColor: "#f2f6f7" } }}
        >
          {t("Back")}
        </Button>
      </Box>
      <Grid container spacing={1}>
        {flag === false && (
          <Grid item xs={12} sm={3} md={3}>
            <InputLabel id="demo-simple-select-label">
              {t("Invoice No.")}
            </InputLabel>
            <TextField
              type={"text"}
              size="small"
              value={flag === false ? getDocumentId({ ...formData, OfferPrice: false, salesReturn: isSalesReturnDraft }) : ""}
              disabled={Number(AppContext?.userInfo?.zatca_phase) === 2}
              sx={{
                "& input": {
                  color:
                    AppContext?.userInfo.role === "user" &&
                    "rgb(105,105,105) !important",
                },
                "& .MuiInputLabel-shrink": {
                  color:
                    AppContext?.userInfo.role === "user"
                      ? "#A0A0A0 !important"
                      : "#41c1ba ",
                },
                width: "80%",
                "& fieldset": {
                  borderColor:
                    AppContext?.userInfo.role === "user"
                      ? "#A0A0A0 !important"
                      : "#41c1ba ",
                  "& legend": {
                    "& span": {
                      color:
                        AppContext?.userInfo.role === "user"
                          ? "#A0A0A0 !important"
                          : "#41c1ba ",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor:
                    AppContext?.userInfo.role === "user"
                      ? "#A0A0A0 !important"
                      : "#41c1ba",
                },
              }}
              inputProps={{ readOnly: Number(AppContext?.userInfo?.zatca_phase) === 2 || !(AppContext?.userInfo?.invoiceNumberEdit === true && (getInvoice === null || duplicate)) }}
              onChange={(event) => setFormData((current) => isSalesReturnDraft
                ? { ...current, sr_document_number: event.target.value.replace(/^RET-/, "") }
                : { ...current, i_document_number: event.target.value.replace(/^INV-/, "") })}
            />
          </Grid>
        )}
        {flag === true && (
          <Grid item xs={12} sm={3} md={3}>
            <InputLabel id="demo-simple-select-label">
              {t("Price Offer No.")}
            </InputLabel>
            <TextField
              type={"text"}
              size="small"
              value={flag === true ? getDocumentId({ ...formData, OfferPrice: true }) : ""}
              sx={{
                "& input": {
                  color:
                    AppContext?.userInfo.role === "user" &&
                    "rgb(105,105,105) !important",
                },
                "& .MuiInputLabel-shrink": {
                  color:
                    AppContext?.userInfo.role === "user"
                      ? "#A0A0A0 !important"
                      : "#41c1ba ",
                },
                width: "80%",
                "& fieldset": {
                  borderColor:
                    AppContext?.userInfo.role === "user"
                      ? "#A0A0A0 !important"
                      : "#41c1ba ",
                  "& legend": {
                    "& span": {
                      color:
                        AppContext?.userInfo.role === "user"
                          ? "#A0A0A0 !important"
                          : "#41c1ba ",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor:
                    AppContext?.userInfo.role === "user"
                      ? "#A0A0A0 !important"
                      : "#41c1ba",
                },
              }}
              inputProps={{ readOnly: !(AppContext?.userInfo?.invoiceNumberEdit === true && (getInvoice === null || duplicate)) }}
              onChange={(event) => setFormData((current) => ({ ...current, po_document_number: event.target.value.replace(/^PO-/, "") }))}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={5} md={3}>
          <Box>
            <InputLabel id="demo-simple-select-label">
              {flag === true ? t("Price Offer Date") : t("Invoice Date")}
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                sx={{
                  padding: "unset !important",
                  height: "2.7em !important",
                }}
                components={["DatePicker"]}
              >
                <DatePicker
                  value={formData.invoiceDate}
                  disabled={
                    (AppContext?.userInfo.dateEdit === true &&
                      getInvoice === null) ||
                      flag === true ||
                      duplicate === true
                      ? false
                      : true
                  }
                  sx={{
                    // height: "1.5375em !important",
                    "& input": {
                      color:
                        AppContext?.userInfo.dateEdit === false &&
                        "rgb(105,105,105) !important",
                      // height: "1.4375em !important",
                      padding: "9px !important",
                    },
                    "& .MuiInputLabel-shrink": {
                      color:
                        AppContext?.userInfo.dateEdit === false &&
                          flag === false
                          ? "#A0A0A0 !important"
                          : "#41c1ba !important",
                      // height: "1.975em !important",
                      padding: "9px !important",
                    },
                    "& fieldset": {
                      borderColor:
                        AppContext?.userInfo.dateEdit === false &&
                          flag === false
                          ? "#A0A0A0 !important"
                          : "#41c1ba !important",
                      "& legend": {
                        "& span": {
                          color:
                            AppContext?.userInfo.dateEdit === false &&
                              flag === false
                              ? "#A0A0A0 !important"
                              : "#41c1ba !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor:
                        AppContext?.userInfo.dateEdit === false &&
                          flag === false
                          ? "#A0A0A0 !important"
                          : "#41c1ba !important",
                    },
                  }}
                  onChange={(newValue) => {
                    const dupObj = { ...formData };
                    dupObj.invoiceDate = newValue;
                    setFormData(dupObj);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Box>
          {!validated &&
            (formData.invoiceDate === null || formData.invoiceDate === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Date is required
              </div>
            )}
        </Grid>

        {flag === false && Number(AppContext?.userInfo?.zatca_phase) === 2 && (
        <Grid item xs={12} sm={3} md={3}>
          <Box>
            <InputLabel id="invoice-category-label">
              {t("Invoice Type (ZATCA)")}
            </InputLabel>
            <Select
              labelId="invoice-category-label"
              size="small"
              value={normalizeInvoiceCategory(formData.invoice_category) || "Simplified"}
              onChange={(e) => {
                const dupObj = { ...formData };
                dupObj.invoice_category = e.target.value;
                setInvoiceCategoryTouched(true);
                setFormData(dupObj);
              }}
              sx={{
                width: "100%",
                "& .MuiInputLabel-shrink": { color: "#41c1ba !important" },
                "& fieldset": { borderColor: "#41c1ba !important" },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#41c1ba" },
              }}
            >
              <MenuItem value="Simplified">{t("Simplified Tax Invoice (B2C)")}</MenuItem>
              <MenuItem value="Standard">{t("Standard Tax Invoice (B2B)")}</MenuItem>
            </Select>
            {formData.invoice_category === "Standard" && (
              <Typography variant="caption" sx={{ color: "#d32f2f", display: "block", mt: 0.5 }}>
                {t("Standard Invoices require a valid 15-digit Buyer VAT number & full address for ZATCA Clearance.")}
              </Typography>
            )}
          </Box>
        </Grid>
        )}
        {/* {flag === true && */}
        <Grid item xs={12} sm={3} md={3}>
          <Box>
            <InputLabel id="demo-simple-select-label">
              {flag === true ? t("Client") : t("Company")}
            </InputLabel>
            <Select
              size="small"
              inputProps={{
                readOnly:
                  flag === false && getInvoice != null && duplicate != true
                    ? true
                    : false,
              }}
              sx={{
                width: "80%",
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
              }}
              value={cleanInputValue(formData.companyName)}
              renderValue={(selected) => (
                <Box component="span" dir="auto">
                  {cleanInputValue(selected)}
                </Box>
              )}
              onChange={(e) => {
                let dupObj = { ...formData };
                const selectedCompanyName = cleanInputValue(e.target.value);
                dupObj.companyName = selectedCompanyName;
                const findClient = clients.find(
                  (data) => cleanInputValue(data.companyName) === selectedCompanyName
                );
                dupObj.vatNumber = cleanInputValue(findClient?.vatNumber);
                dupObj.clientNumber = cleanInputValue(findClient?.companyNumber);
                dupObj.clientPhone = cleanInputValue(findClient?.phoneNumber);
                applyClientBuyerDetails(dupObj, findClient);
                if (!invoiceCategoryTouched) {
                  dupObj.invoice_category =
                    normalizeInvoiceCategory(findClient?.invoiceCategory) || dupObj.invoice_category || "Simplified";
                }
                setFormData(dupObj);
              }}
            >
              {!!clients.length &&
                clients.map((comp) => (
                  <MenuItem key={comp.id} value={cleanInputValue(comp.companyName)}>
                    {cleanInputValue(comp.companyName)}
                  </MenuItem>
                ))}
            </Select>
            {!validated &&
              (formData.companyName === null ||
                formData.companyName === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Select Company
                </div>
              )}
          </Box>
        </Grid>
        {/* } */}
        <Grid item xs={12} sm={3} md={3}>
          <Box>
            <InputLabel id="demo-simple-select-label">
              {t("Vat Number")}
            </InputLabel>
            <TextField
              inputProps={{ readOnly: true }}
              value={cleanInputValue(formData.vatNumber)}
              size="small"
              sx={{
                "& input": {
                  color: "rgb(105,105,105) !important",
                },
                "& .MuiInputLabel-shrink": {
                  color: "#A0A0A0 !important",
                },
                "& fieldset": {
                  borderColor: "#A0A0A0 !important",
                  "& legend": {
                    "& span": {
                      color: "#A0A0A0 !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#A0A0A0",
                },
              }}
            />
          </Box>
        </Grid>

        <>
          <Grid item xs={12} sm={3} md={3}>
            <Box>
              <InputLabel id="demo-simple-select-label">
                {t("Notes")} ({t("optional")})
              </InputLabel>
              <TextField
                value={cleanInputValue(formData.notes)}
                // inputProps={{ readOnly: getInvoice === null ? false : true }}
                size="small"
                sx={{
                  width: "80%",
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                }}
                onChange={(e) => {
                  const dupObj = { ...formData };
                  dupObj.notes = e.target.value;
                  setFormData(dupObj);
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Box>
              <InputLabel id="demo-simple-select-label">
                {t("Notes-2")} ({t("optional")})
              </InputLabel>
              <TextField
                value={cleanInputValue(formData.notes_2)}
                // inputProps={{ readOnly: getInvoice === null ? false : true }}
                size="small"
                sx={{
                  width: "88%",
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                }}
                onChange={(e) => {
                  const dupObj = { ...formData };
                  dupObj.notes_2 = e.target.value;
                  setFormData(dupObj);
                }}
              />
            </Box>
          </Grid>
          {flag === false && (
            <Grid item xs={12} sm={3} md={3}>
              <Box>
                <InputLabel id="demo-simple-select-label">{t("P.O")}</InputLabel>
                <TextField
                  size="small"
                  value={cleanInputValue(formData.po)}
                  onChange={(e) => {
                    const dupObj = { ...formData };
                    dupObj.po = e.target.value;
                    setFormData(dupObj);
                  }}
                  sx={{
                    width: "81%",
                    "& .MuiInputLabel-shrink": {
                      color: "#41c1ba !important",
                    },
                    "& fieldset": {
                      borderColor: "#41c1ba !important",
                      "& legend": {
                        "& span": {
                          color: "#41c1ba !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#41c1ba",
                    },
                  }}
                />
              </Box>
              {/* {!validated &&
              flag === false &&
              (formData.po === null || formData.po === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Enter P.O. to proceed
                </div>
              )} */}
            </Grid>
          )}

          {flag === true && (
            <Grid item xs={12} sm={3} md={3}>
              <Box>
                <InputLabel id="demo-simple-select-label">
                  {t("Validity")}
                </InputLabel>
                <TextField
                  value={cleanInputValue(formData.validity)}
                  size="small"
                  // inputProps={{ readOnly: getInvoice === null ? false : true }}
                  sx={{
                    width: "80%",
                    "& .MuiInputLabel-shrink": {
                      color: "#41c1ba !important",
                    },
                    "& fieldset": {
                      borderColor: "#41c1ba !important",
                      "& legend": {
                        "& span": {
                          color: "#41c1ba !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#41c1ba",
                    },
                  }}
                  onChange={(e) => {
                    const dupObj = { ...formData };
                    dupObj.validity = e.target.value;
                    setFormData(dupObj);
                  }}
                />
              </Box>
            </Grid>
          )}
        </>
        <Grid item xs={12}>
          <Button
            variant="contained"
            sx={{
              width: "100%",
              background: "#365b6d",
              justifyContent: "space-between",
              "&:hover": { backgroundColor: "#365b6d" },
            }}
            onClick={() => {
              const dupObj = { ...formData };
              dupObj.invoiceproducts.push({
                productId: null,
                productName: "",
                description: "",
                qty: null,
                unitPrice: null,
                vat: null,
                total: null,
                discount: 0,
              });
              setFormData(dupObj);
            }}
          >
            {t("Add Product")}
            <FontAwesomeIcon
              style={{ color: "white", width: "1.5em", height: "18px" }}
              icon={faPlus}
            />
          </Button>
        </Grid>
      </Grid>
      <Box
        sx={{
          height: { xs: "360px", md: "calc(100vh - 417px)" },
          overflowY: "scroll",
          marginTop: "12px",
        }}
      >
        {!!formData?.invoiceproducts.length &&
          formData?.invoiceproducts?.map((singleProduct, i) => (
            <AddedElement
              key={i}
              index={i}
              setFormData={setFormData}
              formData={formData}
              product={products}
              singleProduct={singleProduct}
              validate={validated}
              getInvoice={getInvoice}
              flag={flag}
              duplicate={duplicate}
              calculateTotalAfterVat={calculateTotalAfterVat}
              productLabels={productLabels}
              setProductLabels={setProductLabels}
              labels={labels} setLabels={setLabels}
            />
          ))}
        {!validated && formData.invoiceproducts < 1 && (
          <div style={{ color: "red", fontSize: "small" }}>Add Product</div>
        )}
      </Box>
      {AppContext?.userInfo?.addField === true && (
        <>
          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{
                width: "100%",
                background: "#365b6d",
                justifyContent: "space-between",
                "&:hover": { backgroundColor: "#365b6d" },
              }}
              onClick={() => {
                const dupObj = { ...formData };
                dupObj.extraValues.push({
                  text: "",
                  value: null,
                });
                setFormData(dupObj);
              }}
            >
              {t("Add Field")}
              <FontAwesomeIcon
                style={{ color: "white", width: "1.5em", height: "18px" }}
                icon={faPlus}
              />
            </Button>
          </Grid>
          <Box
            sx={{
              height: { xs: "320px", md: "calc(100vh - 500px)" },
              overflowY: "scroll",
              marginTop: "12px",
            }}
          >
            {!!formData?.extraValues.length &&
              formData?.extraValues?.map((singleProduct, i) => (
                <ExtraValues
                  key={i}
                  index={i}
                  setFormData={setFormData}
                  formData={formData}
                  product={products}
                  singleProduct={singleProduct}
                  flag={flag}
                  duplicate={duplicate}
                />
              ))}
          </Box>
        </>
      )}
      {AppContext?.userInfo?.addField === true && <Divider />}
      {AppContext?.userInfo?.allowAddValues === true && (
        <>
          <Grid item xs={12} mt={2}>
            <Button
              variant="contained"
              sx={{
                width: "100%",
                background: "#365b6d",
                justifyContent: "space-between",
                "&:hover": { backgroundColor: "#365b6d" },
              }}
              onClick={() => {
                const dupObj = { ...formData };
                dupObj.addedValues.push({
                  text: "",
                  value: "",
                });
                setFormData(dupObj);
              }}
            >
              {t("Add Values")}
              <FontAwesomeIcon
                style={{ color: "white", width: "1.5em", height: "18px" }}
                icon={faPlus}
              />
            </Button>
          </Grid>
          <Box
            sx={{
              height: { xs: "320px", md: "calc(100vh - 500px)" },
              overflowY: "scroll",
              marginTop: "12px",
            }}
          >
            {!!formData?.addedValues.length &&
              formData?.addedValues?.map((singleProduct, i) => (
                <AddedValues
                  key={i}
                  index={i}
                  setFormData={setFormData}
                  formData={formData}
                  singleProduct={singleProduct}
                  flag={flag}
                  duplicate={duplicate}
                />
              ))}
          </Box>
        </>
      )}
      <Divider />
      <Grid container spacing={2} sx={{ marginTop: "15px" }}>
        {flag === false && (
          <Grid item xs={12} sm={3} md={3}>
            <Box>
              <InputLabel id="demo-simple-select-label">
                {t("Select Payment")}
              </InputLabel>
              <Select
                size="small"
                inputProps={{
                  readOnly:
                    getInvoice != null && duplicate != true ? true : false,
                }}
                sx={{
                  width: "100%",
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                }}
                value={cleanInputValue(formData.payment)}
                onChange={(e) => {
                  const dupObj = { ...formData };
                  dupObj.payment = e.target.value;
                  setFormData(dupObj);
                }}
              >
                <MenuItem value={t("Cash")}>{t("Cash")}</MenuItem>
                <MenuItem value={t("Credit")}>{t("Credit")}</MenuItem>
                <MenuItem value={t("Transfer")}>{t("Transfer")}</MenuItem>
                <MenuItem value={t("Card")}>{t("Card")}</MenuItem>
              </Select>
            </Box>
            {!validated &&
              flag === false &&
              (formData.payment === null || formData.payment === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Select Payment Method
                </div>
              )}
          </Grid>
        )}
        {/* {flag === false && (
          <Grid item xs={12} sm={3} md={2}>
            <Box>
              <InputLabel id="demo-simple-select-label">{t("P.O")}</InputLabel>
              <TextField
                type={"number"}
                inputProps={{
                  readOnly:
                    getInvoice != null && duplicate != true ? true : false,
                }}
                size="small"
                value={formData.po}
                onChange={(e) => {
                  const dupObj = { ...formData };
                  dupObj.po = e.target.value;
                  setFormData(dupObj);
                }}
                sx={{
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                }}
              />
            </Box>
            {!validated &&
              flag === false &&
              (formData.po === null || formData.po === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Enter P.O. to proceed
                </div>
              )}
          </Grid>
        )} */}
        <Grid item xs={12} sm={3} md={3}>
          <InputLabel id="demo-simple-select-label">{t("Price")}</InputLabel>
          <TextField
            type={"number"}
            size="small"
            inputProps={{ readOnly: true }}
            value={cleanInputValue(totalPrice)}
            sx={{
              width: "100%",
              "& input": {
                color: "grey !important",
              },
              "& .MuiInputLabel-shrink": {
                color: "#A0A0A0 !important",
              },
              "& fieldset": {
                borderColor: "#A0A0A0 !important",
                "& legend": {
                  "& span": {
                    color: "#A0A0A0 !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#A0A0A0",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <InputLabel id="demo-simple-select-label">
            {t("Vat")}{" "}
            {AppContext?.userInfo?.allowTax === true &&
              formData?.invoiceproducts?.length <= 1
              ? vatPercentage
              : AppContext?.userInfo?.allowTax === true &&
                formData?.invoiceproducts?.length > 1
                ? ""
                : AppContext.userInfo.vat}
            %
          </InputLabel>
          <TextField
            type={"number"}
            size="small"
            inputProps={{ readOnly: AppContext?.userInfo?.allowTax === true ? false : true }}
            value={cleanInputValue(formData?.vat)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.vat = e.target.value;
              setFormData(dupObj);
            }}
            sx={{
              width: "100%",
              "& input": {
                color: "grey !important",
              },
              "& .MuiInputLabel-shrink": {
                color: "#A0A0A0 !important",
              },
              "& fieldset": {
                borderColor: "#A0A0A0 !important",
                "& legend": {
                  "& span": {
                    color: "#A0A0A0 !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#A0A0A0",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <InputLabel id="demo-simple-select-label">
            {t("Grand Total")}
          </InputLabel>
          <TextField
            type={"text"}
            size="small"
            inputProps={{ readOnly: !AppContext?.userInfo?.allowTotal }}
            value={cleanInputValue(formData?.totalAfterVat)}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.totalAfterVat = e.target.value;
              setFormData(dupObj);
            }}
            sx={{
              "& input": {
                color: "grey !important",
              },
              "& .MuiInputLabel-shrink": {
                color: "#A0A0A0 !important",
              },
              "& fieldset": {
                borderColor: "#A0A0A0 !important",
                "& legend": {
                  "& span": {
                    color: "#A0A0A0 !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#A0A0A0",
              },
              width: "100%",
            }}
          />
        </Grid>
        {/* {flag === true && */}
        <Grid item xs={12} sm={3} md={4}>
          <InputLabel id="demo-simple-select-label">
            {t("Text")} ({t("optional")})
          </InputLabel>
          <TextField
            size="small"
            // inputProps={{ readOnly: getInvoice === null ? false : true }}
            value={cleanInputValue(formData.bank_iban)}
            sx={{
              "& .MuiInputLabel-shrink": {
                color: "#41c1ba !important",
              },
              "& fieldset": {
                borderColor: "#41c1ba !important",
                "& legend": {
                  "& span": {
                    color: "#41c1ba !important",
                  },
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#41c1ba",
              },
            }}
            onChange={(e) => {
              const dupObj = { ...formData };
              dupObj.bank_iban = e.target.value;
              setFormData(dupObj);
            }}
          />
        </Grid>
        {/* } */}
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 1.25, mt: 3 }}>
        <Button
          onClick={() => navigate(cancelPath)}
          variant="outlined"
          sx={{ color: "#365b6d", borderColor: "#aebfc5", backgroundColor: "#fff", "&:hover": { borderColor: "#365b6d", backgroundColor: "#f2f6f7" } }}
        >
          {t("Cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ background: "#365b6d", "&:hover": { backgroundColor: "#365b6d" }, minWidth: "104px" }}
          disabled={isSubmitting}
        >
          {isSubmitting ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : t("Submit")}
        </Button>
      </Box>
    </Box>
  );
}

export default AddInvoice;
